import { render, staticRenderFns } from "./SantamHumanCapitalAward.vue?vue&type=template&id=c085a66a&"
import script from "./SantamHumanCapitalAward.vue?vue&type=script&lang=js&"
export * from "./SantamHumanCapitalAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports